import {Component, Input, OnInit, OnChanges, SimpleChanges} from '@angular/core';
import {MatDialog} from '@angular/material';
import {AttributeDescriptionComponent} from '../crudapi.component';
import {CrudapiComponent} from '../crudapi.component';
import {EditEntityComponent} from '../../edit-entity/edit-entity.component';


declare let $;
@Component({
    selector: 'sub-array',
    templateUrl: './sub-array.component.html',
    styleUrls: ['./sub-array.component.css']
})
export class SubArrayComponent implements OnInit {
    attributes = ['None', 'Primary', 'Unique'];
    // selectDatabase: any;
    datastoragepolicy = ['None', 'Encrypted'];
    apiaccesspolicy = ['None', 'Decrypted', 'Encrypted', 'Masked (All with X)', 'Masked (All with x)', 'Masked (All with *)', 'Masked (xxxx-xxxx-xxxx-####)', 'Masked (xxxxxxxxxxxx####)'];
    @Input() apiByDefinition: any;
    @Input() dataTypeFilter: any;
    @Input() selectDatabase: any;
    @Input() cloneWithData = false;
    @Input() type: any;
    @Input() isAPIDefinitionImportedFromExistingTable = false;
    @Input() isSelectedDatabaseNatureNoSQL: any;
    @Input() selectedDatatypeFilter = '';

    @Input() showPrecision = true;
    @Input() showLength = true;
    @Input() showKeyType = true;
    @Input() showAutoIncrement = true;
    @Input() showDefaultValue = true;

    // ngOnChanges(changes: SimpleChanges) {
    //     this.selectDatabase = changes['dataTypeFilter']['currentValue'][0]['database_type'];
    // }

    constructor(public dialog: MatDialog) {}

    customType = false;
    // selectDatabase = this.crudAPIInstance.selectDatabase || this.editAPIInstance.items['database'];


    ngOnInit(): void {
    }
    sendResponse() {
    }
    addnewrow(val) {
        this.addAttributeField(null, this.apiByDefinition, this.selectDatabase);
    }
    typeCheck(definition, subType) {

        const entityAndVersionCheckString = definition.type,
            substring = '_';
        if (entityAndVersionCheckString.includes(substring)) {
            definition.customType = true;
            definition.attributeType = 'DBRef';
            definition.array = true;
        } else {
            definition.customType = false;
            definition.attributeType = 'None';
            definition.array = false;
        }

        if (this.selectDatabase === 'default' || this.selectDatabase === 'mongo') {
            if (definition.type === 'Array' || definition.type === 'Object') {
                this.addAttributeField(definition, subType, this.selectDatabase);
            } else {
                this.removeAttributeField(definition.subType);
            }
        } else {
            if (definition.type === 'Array' || definition.type === 'Object') {
                this.addAttributeField(definition, subType, this.selectDatabase);
            } else {
                this.removeAttributeField(definition.subType);
            }
        }
    }

    addAttributeField(parent, data, selectDB) {

        if (selectDB === 'mongodb' || selectDB === 'default') {
            const newField = {
                'customType': false,
                'apiAccessPolicy': 'None',
                'attributeName': null,
                'type': null,
                'array': false,
                'size': null,
                'precision': null,
                'autoIncrement': false,
                'defaultValue': null,
                'attributeType': 'None',
                'dataStoragePolicy': 'None',
                'description': null,
                'displayName': null,
                'displayPolicy': null,
                'required': false,
                'subType': []
            };
            if (data == null) {
                parent.subType = [];
                parent.subType.push(newField);
            } else {
                data.push(newField);
            }
        } else {
            const newField = {
                'customType': false,
                'apiAccessPolicy': 'None',
                'attributeName': null,
                'type': null,
                'size': null,
                'precision': null,
                'autoIncrement': false,
                'defaultValue': null,
                'attributeType': 'None',
                'dataStoragePolicy': 'None',
                'description': null,
                'displayName': null,
                'displayPolicy': null,
                'required': false,
                'subType': []
            };
            if (data == null) {
                parent.subType = [];
                parent.subType.push(newField);
            } else {
                data.push(newField);
            }
        }
    }
    removeAttributeField(data) {
        for (let i = 0; i < data.length; i++) {
            data.splice(i, 1);
        }
    }
    removeAttribute(data, index) {
        data.splice(index, 1);
    }
    openAttributeDescriptionDialog(definition) {
        const data = {
            'displayName' : definition.displayName,
            'description' : definition.description,
            'dataStoragePolicy': definition.dataStoragePolicy,
            'apiAccessPolicy': definition.apiAccessPolicy,
            'displayPolicy': definition.displayPolicy
        };
        const dialogRef = this.dialog.open(AttributeDescriptionComponent, {
            data: data
        });

        dialogRef.afterClosed().subscribe(result => {
            definition.displayName = data.displayName;
            definition.description = data.description;
            definition.dataStoragePolicy = data.dataStoragePolicy;
            definition.apiAccessPolicy = data.description;
            definition.displayPolicy = data.displayPolicy;
        });
    }
    toggle(ev) {
        $(ev.target).closest('th').parent('thead').siblings().toggle();
        $(ev.target).toggleClass('fa-angle-double-down fa-angle-double-up');
    }
}
